// extracted by css-extract-rspack-plugin
export default {"codeContainer":"U0ppl"};